import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

const lineKey = (product_id, note) => `${product_id}|${note || ""}`;

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    if (typeof window === "undefined") return [];
    try {
      const stored = JSON.parse(localStorage.getItem("cart") || "[]");
      return stored.map((i) => ({ ...i, note: i.note || "", key: lineKey(i.product_id, i.note) }));
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1, note = "") => {
    const cleanNote = note.trim();
    const key = lineKey(product.id, cleanNote);
    setItems((prev) => {
      const existing = prev.find((i) => i.key === key);
      if (existing) {
        return prev.map((i) => (i.key === key ? { ...i, quantity: i.quantity + qty } : i));
      }
      return [
        ...prev,
        {
          key,
          product_id: product.id,
          quantity: qty,
          note: cleanNote,
          name: product.name,
          price: product.price,
          image_url: product.image_url,
        },
      ];
    });
  };

  const setQty = (key, qty) => {
    setItems((prev) =>
      prev.map((i) => (i.key === key ? { ...i, quantity: Math.max(1, qty) } : i))
    );
  };

  const remove = (key) => {
    setItems((prev) => prev.filter((i) => i.key !== key));
  };

  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
